class UnsavedChangesService {
  get hasUnsavedChanges () {
    return !!this.revertFunction
  }

  registerUnsavedChanges (revertFunction) {
    this.revertFunction = revertFunction
  }

  revert () {
    if (this.revertFunction) {
      this.revertFunction()
    }
  }

  clearUnsavedChanges () {
    this.revertFunction = null
  }

  beforeUnload (event) {
    if (this.hasUnsavedChanges) {
      event.preventDefault()
      event.returnValue = true
    }
  }
}

export const unsavedChangesService = new UnsavedChangesService()
